import { Routes } from '@angular/router';

import { authGuard } from '@guards/auth.guard';
import { roleGuard } from '@guards/role.guard';

import { APP_PATHS, APP_PATHS_CONFIG, NOT_FOUND_PATHS } from './core/enums/paths/app.paths';

export const routes: Routes = [
  {
    path: APP_PATHS.SIGN_IN,
    loadChildren: () => import('./pages/login/login.routes').then(m => m.routes),
  },
  ...APP_PATHS_CONFIG.map(({ path, load, data }) => ({
    path,
    canActivate: [authGuard, roleGuard],
    loadChildren: () => load().then(m => m.routes),
    ...(data && { data }),
  })),
  ...NOT_FOUND_PATHS.map(path => ({
    path,
    canActivate: [authGuard],
    loadChildren: () => import('./pages/not-found/not-found.routes').then(m => m.routes),
  })),
  {
    path: '**',
    redirectTo: APP_PATHS.HOME,
    pathMatch: 'full' as const,
  },
];
